import { render, staticRenderFns } from "./xcDialog.vue?vue&type=template&id=3796e3f5&scoped=true&"
import script from "./xcDialog.vue?vue&type=script&lang=js&"
export * from "./xcDialog.vue?vue&type=script&lang=js&"
import style0 from "./xcDialog.vue?vue&type=style&index=0&id=3796e3f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796e3f5",
  null
  
)

export default component.exports